import { RestClient } from "clients/rest";

export type B080010FindRequest = {
  shukaYmdFrom: string;
  shohinshubetsuKbn: string;
} & Partial<{
  shukaYmdTo: string;
  hasokbnCd: string;
  hasosakiCd: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
  nonyuCdFrom: string;
  nonyushitenCdFrom: string;
  nonyuCdTo: string;
  nonyushitenCdTo: string;
  denpyoshubetsuCd: string;
  ppgakeKbn: string;
  netsukeKbn: string;
}>;

export type B080010JuchudenpyoNo = {
  juchudenpyoNo: string;
};

export type B080010FindResponse = {
  shukakanoukensu: string;
  honjitsuizenkensu: string;
  asitakensu: string;
  asatteikokensu: string;
  taisyoshukakensu: string;
  juchudenpyoNoList: B080010JuchudenpyoNo[];
};

// 検索処理
export const B080010Find = (props: B080010FindRequest) => {
  return RestClient.get<B080010FindResponse>("b080010/find", {
    params: props,
  });
};

export type B080010CreateRequest = {
  shukashijiYmd: string;
  juchudenpyoNoList: B080010JuchudenpyoNo[];
};

// 登録処理
export const B080010Create = (props: B080010CreateRequest) => {
  return RestClient.post("b080010/create", props);
};
